<script setup lang="ts">
import { computed } from "vue"
import { RouterLink, useRoute } from "vue-router"

import Icon from "@/components/shared/Icon.vue"

const {
  path,
  icon,
  name,
  activeFor = [],
} = defineProps({
  path: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  activeFor: {
    type: Array<string>,
    default: () => [],
  },
  excludeFor: {
    type: Array<string>,
    default: () => [],
  },
  badge: {
    type: [String, null],
    default: null,
  },
})

const route = useRoute()

const isActive = computed(() => {
  return activeFor.length > 0 ? activeFor.some((prefix) => route.path.startsWith(prefix)) : false
})
const beExact = computed(() => {
  return activeFor.length === 0
})
</script>

<template>
  <RouterLink
    :to="path"
    :class="['menu-item d-flex align-items-center', { 'router-link-active': isActive }]"
    :exact="beExact"
  >
    <Icon :icon="icon" fixedWidth duotone />
    <span>{{ name }}</span>
    <span v-if="badge" class="ms-auto badge text-bg-danger">{{ badge }}</span>
  </RouterLink>
</template>

<style scoped>
.menu-item {
  padding: 0.75rem;
  border-radius: 5px;
  text-decoration: none;
  color: #403d38;
}

.menu-item i {
  font-size: 14px;
  margin-right: 6px;
}

.menu-item span {
  font-weight: 500;
  font-size: 16px;
}

.menu-item span.badge {
  font-size: 12px;
}

.menu-item.router-link-active {
  background-color: #4fc9da;
  color: white;
}

.menu-item + .menu-item {
  margin-top: 0.25rem;
}
</style>
